import { useQuery } from "@tanstack/react-query";
import { Wifi, WifiOff } from "lucide-react";

import { orpc } from "@/client";
import { useMessagingConnected } from "@/hooks/use-messaging-events";
import { cn } from "@/lib/utils";

const STATUS = {
	reconnecting: {
		label: "Reconectando",
		title: "Tentando restabelecer a conexão com o Pulso.",
		icon: WifiOff,
	},
	delayed: {
		label: "Integração com atraso",
		title: "Há atualizações pendentes na integração. As mensagens salvas continuam disponíveis.",
		icon: Wifi,
	},
	recovery: {
		label: "Atualização por recuperação",
		title: "O webhook ainda não foi ativado. A recuperação de mensagens continua no servidor.",
		icon: Wifi,
	},
	connected: {
		label: "Conectado",
		title: "Conectado ao Pulso. O recebimento também depende do SendPulse.",
		icon: Wifi,
	},
};

export function MessagingStatus() {
	const connected = useMessagingConnected();
	const { data } = useQuery(
		orpc.realtime.health.queryOptions({ staleTime: Infinity, refetchOnWindowFocus: false }),
	);
	const delayed = !!data?.failed_jobs || !!data?.unsupported || !!data?.degraded;
	const phase = connected
		? delayed
			? "delayed"
			: data?.configured
				? "connected"
				: "recovery"
		: "reconnecting";
	const Icon = STATUS[phase].icon;

	return (
		<span
			role="status"
			title={STATUS[phase].title}
			className={cn(
				"status-badge gap-1",
				phase === "connected" ? "bg-success-soft text-success" : "bg-warning-soft text-warning",
			)}
		>
			<Icon className="size-3" />
			{STATUS[phase].label}
		</span>
	);
}
